<crm-multi-select
  [filtersUiVersion]="filtersUiVersion"
  #multiSelectComponent
  [options]="entities"
  [selectedItems]="_selectedEntities"
  (selectedItemsChange)="onSelect($event)"
  [label]="isFloatLabel ? label : ''"
  (panelShow)="onShowPanel()"
  (panelHide)="onPanelHide($event)"
  (onFilter)="search($event.filter)"
  [showToggleAll]="true"
  [virtualScroll]="true"
  [virtualScrollItemSize]="50"
  [class]="class + (isError ? ' ng-invalid ng-dirty' : '')"
  [styleClass]="styleClass + (isError ? ' ng-invalid ng-dirty' : '')"
  [disabled]="disabled"
  [appendTo]="appendTo"
  [showClear]="showClear"
  [placeholder]="placeholder"
  [loading]="selectionLoading"
  filterBy="name,code">
  <ng-template
    #selectedItemsTemplate
    let-accounts="items">
    <ng-container *ngFor="let account of accounts; last as isLast">
      <div
        *ngIf="toAccount(account) as account"
        [ngClass]="itemStyleClass">
        <span [innerHTML]="highlightMatchText(account.name) | safeHtml"></span>
        {{ isLast ? '' : ', ' }}
      </div>
    </ng-container>
  </ng-template>
  <ng-template
    #itemTemplate
    let-account="item">
    <div
      *ngIf="toAccount(account) as account"
      [ngClass]="itemStyleClass">
      <p>
        <span [innerHTML]="highlightMatchText(account.name) | safeHtml"></span>
      </p>
      <p class="frm-color-green text-sm">{{ account.code }}</p>
    </div>
  </ng-template>

  <ng-template #footerTemplate>
    <crm-spinner
      *ngIf="paginationLoading"
      top=""
      text=""
      [height]="35"
      [width]="35"
      bottom=""></crm-spinner>
  </ng-template>
</crm-multi-select>
